'use client';

import { c as _c } from "react/compiler-runtime";
import FAQAccordion from '@/app/[locale]/(create)/components/FAQAccordion';
import { getViverseAndroidAppUrl, getViverseIosAppUrl } from '@/constants/mobile';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';
const faqKeys = ['different', 'account', 'card', 'trial-once', 'trial-end', 'billing', 'renewal', 'cancel', 'refund', 'progress', 'catalog', 'devices', 'kids-mode-enable', 'kids-mode-effect', 'mobile', 'download', 'ads', 'refund-policy', 'plan-switch'] as const;
export default function FAQSection() {
  const $ = _c(25);
  const t = useTranslations();
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t) {
    const faqs = faqKeys.map(key => {
      const question = t(`plus.faq.items.${key}.question`);
      if (key === "mobile") {
        return {
          question,
          answer: t.rich("plus.faq.items.mobile.answer", {
            appStore: _temp,
            googlePlay: _temp2
          })
        };
      }
      if (key === "refund-policy") {
        return {
          question,
          answer: t.rich("plus.faq.items.refund-policy.answer", {
            mailto: _temp3
          })
        };
      }
      return {
        question,
        answer: t(`plus.faq.items.${key}.answer`)
      };
    });
    t3 = "3xl:px-[120px] relative flex flex-1 flex-col items-center justify-center gap-12 px-4 py-8 md:gap-20 md:px-10 lg:px-20 lg:pt-24 lg:pb-12";
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        opacity: 0,
        y: 20
      };
      t6 = {
        opacity: 1,
        y: 0
      };
      t7 = {
        once: true,
        amount: 0.2
      };
      t8 = {
        duration: 0.8,
        ease: "easeOut"
      };
      $[6] = t5;
      $[7] = t6;
      $[8] = t7;
      $[9] = t8;
    } else {
      t5 = $[6];
      t6 = $[7];
      t7 = $[8];
      t8 = $[9];
    }
    const t9 = t("plus.faq.title-prefix");
    const t10 = t("plus.faq.title-highlight");
    let t11;
    if ($[10] !== t10) {
      t11 = <span className="text-primary">{t10}</span>;
      $[10] = t10;
      $[11] = t11;
    } else {
      t11 = $[11];
    }
    if ($[12] !== t11 || $[13] !== t9) {
      t4 = <motion.div initial={t5} whileInView={t6} viewport={t7} transition={t8} className="md:header-2 header-3 inline w-full text-center"><span>{t9}{" "}{t11}</span></motion.div>;
      $[12] = t11;
      $[13] = t9;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t2 = "relative grid w-full place-items-center lg:max-w-[70%]";
    t0 = "flex w-full flex-1 flex-col gap-4";
    t1 = faqs.map(_temp4);
    $[0] = t;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[15] !== t0 || $[16] !== t1) {
    t5 = <div className={t0}>{t1}</div>;
    $[15] = t0;
    $[16] = t1;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t2 || $[19] !== t5) {
    t6 = <div className={t2}>{t5}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t3 || $[22] !== t4 || $[23] !== t6) {
    t7 = <section className={t3}>{t4}{t6}</section>;
    $[21] = t3;
    $[22] = t4;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}
function _temp4(faq, i) {
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.6,
    ease: "easeOut"
  }} key={faq.question}><FAQAccordion index={i} {...faq} /></motion.div>;
}
function _temp3(chunks_1) {
  return <a href="mailto:support@viverse.com" className="subheader-1 text-white hover:underline">{chunks_1}</a>;
}
function _temp2(chunks_0) {
  return <a href={getViverseAndroidAppUrl()} target="_blank" rel="noreferrer" className="subheader-1 text-white hover:underline">{chunks_0}</a>;
}
function _temp(chunks) {
  return <a href={getViverseIosAppUrl()} target="_blank" rel="noreferrer" className="subheader-1 text-white hover:underline">{chunks}</a>;
}